<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              New User
            </h4>
            <h6 class="card-subtitle">
              You have been invited to join TruVito.
            </h6>
          </div>
          <form class="form-horizontal" @submit.prevent="handleSubmit">
            <div class="card-body card-blue">
              <h6 class="card-title">
                User Information
              </h6>

              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="first_name">First Name</label>
                <div class="col-sm-5">
                  <input id="first_name" v-model="credentials.user.first_name" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('first_name')}" class="form-control" data-vv-as="First Name" name="first_name" placeholder="First Name" type="text">
                  <div v-if="submitted && errors.has('first_name')" class="invalid-feedback">
                    {{ errors.first('first_name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="last_name">Last Name</label>
                <div class="col-sm-5">
                  <input id="last_name" v-model="credentials.user.last_name" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('last_name')}" class="form-control" data-vv-as="Last Name" name="last_name" placeholder="Last Name" type="text">
                  <div v-if="submitted && errors.has('last_name')" class="invalid-feedback">
                    {{ errors.first('last_name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="password">Password</label>
                <div class="col-sm-5">
                  <input id="password" ref="password" v-model="credentials.user.password" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('password')}" class="form-control" data-vv-as="Password" name="password" placeholder="Password" type="password">
                  <div v-if="submitted && errors.has('password')" class="invalid-feedback">
                    {{ errors.first('password') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="confirm_password">Confirm Password</label>
                <div class="col-sm-5">
                  <input id="confirm_password" v-model="credentials.user.confirm_password" v-validate="'required|confirmed:password'" :class="{'is-invalid': submitted && errors.has('confirm_password')}" class="form-control" data-vv-as="Confirm Password" name="confirm_password" placeholder="Confirm Password" type="password">
                  <div v-if="submitted && errors.has('confirm_password')" class="invalid-feedback">
                    {{ errors.first('confirm_password') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body card-blue">
              <h6 class="card-title">
                Address Information
              </h6>

              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="line1">Address</label>
                <div class="col-sm-3">
                  <input id="line1" v-model="credentials.address.line1" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('line1')}" class="form-control" data-vv-as="Address Line 1" name="line1" placeholder="Address Line 1" type="text">
                  <div v-if="submitted && errors.has('line1')" class="invalid-feedback">
                    {{ errors.first('line1') }}
                  </div>
                </div>
                <div class="col-sm-3">
                  <input id="line2" v-model="credentials.address.line2" :class="{'is-invalid': submitted && errors.has('line2')}" class="form-control" data-vv-as="Address Line 2" name="line2" placeholder="Address Line 2" type="text">
                  <div v-if="submitted && errors.has('line2')" class="invalid-feedback">
                    {{ errors.first('line2') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="city" />
                <div class="col-sm-3">
                  <input id="city" v-model="credentials.address.city" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('city')}" class="form-control" data-vv-as="City" name="city" placeholder="City" type="text">
                  <div v-if="submitted && errors.has('city')" class="invalid-feedback">
                    {{ errors.first('city') }}
                  </div>
                </div>
                <div class="col-sm-3">
                  <input id="state" v-model="credentials.address.state" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('state')}" class="form-control" data-vv-as="State" name="state" placeholder="State or Province" type="text">
                  <div v-if="submitted && errors.has('state')" class="invalid-feedback">
                    {{ errors.first('state') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="postal_code" />
                <div class="col-sm-3">
                  <input id="postal_code" v-model="credentials.address.postal_code" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('postal_code')}" class="form-control" data-vv-as="Postal Code" name="postal_code" placeholder="Postal Code" type="text">
                  <div v-if="submitted && errors.has('postal_code')" class="invalid-feedback">
                    {{ errors.first('postal_code') }}
                  </div>
                </div>
                <div class="col-sm-4">
                  <multiselect id="country" v-model="selectedCountry" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('country')}" :options="countries" class="form-control" data-vv-as="Country" label="name" name="country" placeholder="Country" track-by="code" />

                  <div v-if="submitted && errors.has('country')" class="invalid-feedback">
                    {{ errors.first('country') }}
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div class="form-group m-b-0 text-right">
                <div class="button-group">
                  <button class="btn waves-effect waves-light btn-success" type="submit">
                    Register
                  </button>
                  <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import countries from '../../../assets/js/countries'

export default {
  name: 'Signup',
  components: { Multiselect },
  data () {
    return {
      loading: false,
      submitted: false,
      pwdMismatch: false,
      credentials: {
        user: {
          first_name: null,
          last_name: null,
          password: null,
          confirm_password: null
        },
        address: {
          line1: null,
          line2: null,
          city: null,
          state: null,
          postal_code: null,
          country: null,
          country_code: null
        }
      },
      countries: countries,
      selectedCountry: {
        code: null,
        name: null
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      $('[data-toggle="tooltip"]').tooltip()
      $('.preloader').fadeOut()

      $('#to-recover').on('click', function () {
        $('#notifyform').slideUp()
        $('#recoverform').fadeIn()
      })
    },
    handleSubmit () {
      this.submitted = true
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.register()
          }
        })
    },
    async register () {
      try {
        this.credentials.address.country = this.selectedCountry.name
        this.credentials.address.country_code = this.selectedCountry.code
        console.log(this.credentials, this.$route.query)
        await this.$api.post('/register', { credentials: this.credentials, referral_id: this.$route.query.referral_id })
        this.$toastr('success', 'Registration Complete', 'Success')
        await this.$router.push({ name: 'login' })
      } catch (e) {
        this.$toastr('error', e.response.data.err, 'Error')
      }
    }
  }
}
</script>

<style scoped>
</style>
